import {DestroyRef,Injectable,inject} from '@angular/core';
import {NavigationEnd,Router} from '@angular/router';
import {filter} from 'rxjs';
import {X_PIXEL} from './x-pixel.tokens';

@Injectable({providedIn:'root'})
export class XPixelService{
	private readonly router=inject(Router);
	private readonly destroyRef=inject(DestroyRef);
	private readonly load=inject(X_PIXEL);
	private started=false;

	async start():Promise<void>{
		if(this.started) return;
		const pixel=await this.load();
		if(!pixel) return;
		this.started=true;

		pixel('track','PageView');

		const subscription=this.router.events.pipe(
			filter((event):event is NavigationEnd=>event instanceof NavigationEnd)
		).subscribe(()=>pixel('track','PageView'));
		this.destroyRef.onDestroy(()=>subscription.unsubscribe());
	}
}
